<template lang="pug">
  .categpry-post
    component(:is="view")
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex';

import ContentPage from '@/views/ContentPage';

export default {
  name: 'CategoryPost',
  components: {
    ContentPage
  },
  computed: {
    ...mapGetters({
      view: 'view'
    })
  }
};
</script>

<style lang="sass" scoped></style>
